module.exports = ".modal__wrap {\n  overflow: hidden; }\n"